const CUSTOMER_TRANSFER_FEE_RATE = 0.55
// グローバルエステート
// 送客手数料率(税込) = 0.55
export function calcCustomerTransferFeeRate(): number {
  return CUSTOMER_TRANSFER_FEE_RATE
}
